export enum gitProviderName { // sync with back
    CODECOMMIT = 'code_commit',
    GITHUB = 'github',
    GITLAB = 'gitlab',
}

export const gitProvidersDisplayNames = {
    [gitProviderName.CODECOMMIT]: 'Code commit',
    [gitProviderName.GITHUB]: 'Github',
    [gitProviderName.GITLAB]: 'Gitlab',
};
export const gitProvidersDisplayNamesList = Object.keys(
    gitProvidersDisplayNames
);

export interface GitlabConfig {
    namespace_id?: string;
    token: string;
    host?: string;
}

export interface GithubConfig {
    accessToken: string;
    orgName: string;
}

export interface GitProvider {
    provider?: string;
    githubConfig?: GithubConfig;
    gitlabConfig?: GitlabConfig;
}
